import React from "react";
import WeatherApp from "./WeatherApp.js";
import "./WeatherApp.css";

export default function App() {
  return (
    <div className="App">
      <WeatherApp />
    </div>
  );
}
